import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HeadBar from './HeadBar';
import { styled } from '@mui/material/styles';

export default function SuccessRegister() {

  const { state } = useLocation();

  const CustomTypo1 = styled('typography')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      fontSize: 16, 
      width: 500, 
      position: 'absolute', 
      bottom: 60,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16, 
      paddingLeft: 20,
      paddingRight: 20,
      position: 'absolute', 
      bottom: 60, 
    },
  }));

  const CustomTypo2 = styled('typography')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      fontSize: 16, 
      paddingTop: 8, 
      position: 'absolute', 
      bottom: 30,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16, 
      position: 'absolute', 
      bottom: 30,
    },
  }));

  return (
    <div>
      <HeadBar />

      <Box backgroundColor={'#A7DB8C'} paddingY={1} sx={{ textAlign: 'center' }}>
        <Typography>Registration Success!</Typography>
        <Typography style={{ fontWeight: 'bold' }}>Screenshot now to save your password.</Typography>
      </Box>

      <Box>
        <Box sx={{ justifyContent: "", marginTop: "2%", display: "flex", flexDirection: "column", alignItems: "center" }}>

          {/* <Typography style={{ fontSize: 14, width: 290, paddingLeft: 40, color: 'red' }}>Your account will be ready in one hour's time.</Typography>
          <Box height={10}></Box> */}

          <Typography style={{ fontSize: 18, fontWeight: 'bold', width: 250 }}>Your Password</Typography>
          <Typography style={{ fontSize: 40, width: 250 }}>{state.password}</Typography>
          <Box height={10}></Box>

          <Typography style={{ fontSize: 18, fontWeight: 'bold', width: 250 }}>Residential College/Hall</Typography>
          <Typography style={{ width: 250 }}>{state.rc}</Typography>
          <Box height={20}></Box>

          <Typography style={{ fontSize: 18, fontWeight: 'bold', width: 250 }}>Block</Typography>
          <Typography style={{ width: 250 }}>{state.block}</Typography>
          <Box height={20}></Box>

          <Typography style={{ fontSize: 18, fontWeight: 'bold', width: 250 }}>Room Number</Typography>
          <Typography style={{ width: 250 }}>{state.floor}/{state.room}</Typography>
          <Box height={20}></Box>

          <CustomTypo1>
            Thank you for registering. You may use your password to log in
            at the Resource Sorting Station in about <strong>an hour's time</strong> as we
            update our records.
          </CustomTypo1>
          <CustomTypo2>
            Visit the <a href='https://nus.edu.sg/zerowaste'>NUS Zero Waste website</a> to learn more!
          </CustomTypo2>
        </Box>
      </Box>
    </div>
  );
}

// const styles = StyleSheet.create({
//   infoStyle1: {

//   },
//   infoStyle2: {

//   }
// });